/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {

    @Decorators.gcontent
    export class SeznamAdeTridaAkce extends GContentBase<SeznamAdeTridaAkceObj> {
        private seznamObj: SeznamAdeTridaAkceObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdeTridaAkceObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdeTridaAkce",
                contentCaption: "jres:33000400", //RC 33000400 : Třída akce
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_tri}"
                },
                gridSettings: {
                    columnOrder: "nazev,zkratka,poznamka,rok_od,rok_do,dat_zmena,zmenu_provedl"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdeTridaAkceObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdeTridaAkce", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdeTridaAkce",
                newRecord: isNew,
                ixs_tri: isNew == true ? null : data.ixs_tri
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar([
                "actOpenDetail*", "actNewDetail*", "actAddToComparison*",
                {
                    type: "static", caption: "jres:33000415", icon: "fa-expand", favorite: true, children: [ //RC 33000415 : Vlastnosti
                        {
                            action: this.cnt.actions.actOpenSeznamAdmVlastnostTypObjektu
                        },
                        {
                            action: this.cnt.actions.actOpenSeznamAdmVlastnostObecnyObjekt
                        },
                        {
                            action: this.cnt.actions.actOpenBaseDialogHromadneVlastnosti
                        }
                    ]
                }
            ]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenSeznamAdmVlastnostObecnyObjekt*"])
        }

        createFilterForm() {
           
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdeTridaAkce.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSeznamAdmVlastnostObecnyObjekt?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_tri),
                nazev: data.nazev
            }
        }
    } 
}